import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import FirstRunExperiencePage, { hasSeenFre } from '@/pages/FirstRunExperiencePage';

// Wrapper that re-checks localStorage on every navigation
const RequireFreSeen: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();
  // location changes on every navigate, so this re-evaluates hasSeenFre() fresh
  if (!hasSeenFre()) {
    return <Navigate to="/welcome" replace state={{ from: location }} />;
  }
  return children;
};

const AppRouter = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="loading">Зареждане...</div>;
  }

  return (
    <Routes>
      <Route
        path="/welcome"
        element={isAuthenticated ? <Navigate to="/" replace /> : <FirstRunExperiencePage />}
      />
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/" replace />
          ) : (
            <RequireFreSeen>
              <LoginPage />
            </RequireFreSeen>
          )
        }
      />
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <DashboardPage />
          ) : (
            <RequireFreSeen>
              <Navigate to="/login" replace />
            </RequireFreSeen>
          )
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRouter;
